var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-card"},[_c('div',{staticClass:"card col-md-6"},[_c('h3',[_vm._v("Vaccinare")]),_c('p',[_vm._v("astfel sistemul imunitar al bebelușului va produce anticorpi pregătiți să elimine agenții patogeni pentru care s-a făcut vaccinul. ")])])])
}]

export { render, staticRenderFns }